export default "__VITE_ASSET__CRHU9p6t__"